import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Layout from './pages/Layout';
import Home from './pages/Home';
import AssetList from './pages/AssetList';
import AssetDetail from './pages/AssetDetail';
import ApplyBorrow from './pages/ApplyBorrow';
import ApplyChange from './pages/ApplyChange';
import ApplyScrap from './pages/ApplyScrap';
import Return from './pages/Return';
import Approve from './pages/Approve';
import Inventory from './pages/Inventory';
import InventoryTask from './pages/InventoryTask';
import InventoryRoom from './pages/InventoryRoom';
import Disposal from './pages/Disposal';
import Messages from './pages/Messages';
import Profile from './pages/Profile';
import MyInfo from './pages/MyInfo';
import Settings from './pages/Settings';
import MyApplies from './pages/MyApplies';
import ChangePassword from './pages/ChangePassword';
import AdminUsers from './pages/admin/Users';
import AdminLocations from './pages/admin/Locations';
import AdminRegions from './pages/admin/Regions';
import AdminPartitions from './pages/admin/Partitions';
import AdminAssets from './pages/admin/Assets';
import AdminAnnouncements from './pages/admin/Announcements';
import AdminPermissions from './pages/admin/Permissions';
import AdminApprovals from './pages/admin/Approvals';
import AdminOpLogs from './pages/admin/OpLogs';
import AdminLayout from './pages/admin/AdminLayout';

function PrivateRoute({ children }) {
  return localStorage.getItem('token') ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Home />} />
        <Route path="assets" element={<AssetList />} />
        <Route path="assets/:id" element={<AssetDetail />} />
        <Route path="apply-borrow" element={<ApplyBorrow />} />
        <Route path="apply-change/:id" element={<ApplyChange />} />
        <Route path="apply-scrap/:id" element={<ApplyScrap />} />
        <Route path="return" element={<Return />} />
        <Route path="approve" element={<Approve />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="inventory/:taskId" element={<InventoryTask />} />
        <Route path="inventory/:taskId/location/:locationId" element={<InventoryRoom />} />
        <Route path="disposal" element={<Disposal />} />
        <Route path="messages" element={<Messages />} />
        <Route path="profile" element={<Profile />} />
        <Route path="profile/my-info" element={<MyInfo />} />
        <Route path="profile/settings" element={<Settings />} />
        <Route path="my-applies" element={<MyApplies />} />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>
      <Route path="/admin" element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
        <Route path="users" element={<AdminUsers />} />
        <Route path="asset-users" element={<Navigate to="/admin/users" replace />} />
        <Route path="locations" element={<AdminLocations />} />
        <Route path="regions" element={<AdminRegions />} />
        <Route path="partitions" element={<AdminPartitions />} />
        <Route path="permissions" element={<AdminPermissions />} />
        <Route path="assets" element={<AdminAssets />} />
        <Route path="announcements" element={<AdminAnnouncements />} />
        <Route path="approvals" element={<AdminApprovals />} />
        <Route path="op-logs" element={<AdminOpLogs />} />
        <Route index element={<Navigate to="users" />} />
      </Route>
    </Routes>
  );
}
